import React, { Fragment } from 'react'
import { PhotoItem, PhotoAddBtn } from 'atoms/Photos'
import { Label } from 'atoms/Texts'
import { WrapContainer } from './styles'

const GridPhotos = ({ photos, isAbleToAdd, inputId, largeMode, previewOnClick }) => {
  return (
    <>
    <WrapContainer>
      {isAbleToAdd &&
        <PhotoAddBtn inputId={inputId} />
      }
      {!largeMode && (photos && photos.length > 0 ?
        <Fragment>
          {photos.map((pic, i) => (
            <PhotoItem key={i} pic={pic} shouldBeBase64={isAbleToAdd} previewOnClick={previewOnClick} />)
          )}
        </Fragment> :
        <Label mb={'0'}>No Photos Attached</Label>
      )}
    </WrapContainer>
    {largeMode && (photos && photos.length > 0 ? 
        <div className='row col-12 mt-2'>
        {photos.map((pic, i) => (
            <div key={`${typeof pic === 'string' ? pic.slice(-30) : pic.mediaContentId}${i}`} className='col-6 border'>
              <PhotoItem key={`${typeof pic === 'string' ? pic.slice(-30) : pic.mediaContentId}${i}`} pic={pic} shouldBeBase64={isAbleToAdd} height="10em" width="100%" previewOnClick={previewOnClick} />
            </div>
          )
        )}
        </div> 
      :
      <Label mb={'0'}>No Photos Attached</Label>)}
    </>
  )
}

export default GridPhotos
